import { Icon } from '@iconify/react'
import {
  IonButton, IonInput, IonRow,
} from '@ionic/react'
import * as React from 'react'
import { useChatsData } from '../../hooks/chats/useChatsData'
import { useAuth } from '../../hooks/useAuth'
import ChatCard from './ChatCard'
import { TabBarContainer } from './StyledContainers'

const TabBarChats : React.FC = () => {
  const [searchText, setSearchText] = React.useState<string>('')
  const {
    rooms, setShowAddChat, setFocusedRoom, focusedRoom,
  } = useChatsData()
  const { user } = useAuth()

  return (
    <TabBarContainer style={{ maxHeight: '100%', overflow: 'auto' }}>
      <div style={{ padding: '10px', margin: '30px 15px' }}>
        <IonRow className='ion-justify-content-between ion-align-items-center'>
          <h3 className='chat-title'>Chat</h3>
          <IonButton
            fill='clear'
            class='ion-justify-content-end'
            onClick={() => {
              setShowAddChat(true)
            }}
          >
            <Icon type='button' icon='entypo:new-message' color='#326771' style={{ fontSize: '1.5em' }} />
          </IonButton>
        </IonRow>
        <IonInput
          type='text'
          placeholder='Search Messages'
          className='chats-input-field'
          name='name'
          value={searchText}
          onIonChange={(e) => setSearchText(e.detail.value)}
        />
      </div>
      {
        rooms.length === 0 ? (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <h3 style={{ textAlign: 'center' }}>No Current Conversations</h3>
            <p>Your conversations will appear here. </p>
          </div>
        ) : (
          <div style={{ height: '100%', overflowY: 'auto' }}>
            {
              rooms.map((val) => (
                <ChatCard userId={user.user_id} key={val.id} {...val} onClick={() => setFocusedRoom({ ...val })} selected={focusedRoom && focusedRoom.id === val.id} />
              ))
            }
          </div>
        )
      }
    </TabBarContainer>
  )
}

export default TabBarChats
